export default __webpack_public_path__ + "static/media/avatar.a2d6e293.jpg";